//React
import React from "react"
import { useNavigate } from "react-router-dom"
//Infinite Scroll
import { useInView } from "react-cool-inview"
//Icons
import { faAdd } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
//Components
import MainContainer from "../../../Components/Containers/MainContainer"
import SideContainer from "../../../Components/Containers/SideContainer"
import ContactList from "../Components/ContactList"

export default function Home({
  contacts,
  setPagination,
  pagination,
  showMore,
  listContacts,
  count,
  tagList,
}) {
  const navigate = useNavigate()

  const { observe } = useInView({
    onEnter: () => {
      listContacts()
    },
  })
  return (
    <div>
      <SideContainer classes={"d-xl-none"}>
        <ContactList
          contacts={contacts}
          setPagination={setPagination}
          pagination={pagination}
          count={count}
          tagList={tagList}
        >
          {showMore && <div ref={observe} className="pb-5"></div>}
        </ContactList>
      </SideContainer>
      <MainContainer
        classes={
          "d-none d-xl-flex justify-content-center align-items-center p-4"
        }
      >
        <div>
          Select a contact or click
          <button
            className="btn btn-primary mx-2"
            onClick={() => navigate("./create_contact")}
          >
            <FontAwesomeIcon icon={faAdd} />
          </button>
          to create a new contact
        </div>
      </MainContainer>
    </div>
  )
}
